// extracted by mini-css-extract-plugin
export default {"loading-icon":"_2itk6","loadingIcon":"_2itk6","loading-opacity":"_39azO","loadingOpacity":"_39azO"};